import React, { FC } from 'react'
import { Spinner } from '@mailstep/design-system/ui/Elements/Spinner'
import { Trans } from '@lingui/react'
import { H6 } from '@mailstep/design-system/ui/Elements/Typography'
import { ApolloError } from '@apollo/client'
import { x } from '@xstyled/styled-components'

type SerialNumbersListProps = {
  loading: boolean
  error?: ApolloError
  serialNumbersList?: string[]
}

export const SerialNumbersList: FC<SerialNumbersListProps> = ({ loading, error, serialNumbersList }) => {
  if (loading) return <Spinner />

  return (
    <div>
      {error && String(error)}

      <H6>
        <Trans id="serialNumbers" message="Serial numbers" />:
      </H6>

      {!serialNumbersList?.length && <Trans id="noSerialNumbers" message="No serial numbers found" />}

      <ul>
        {serialNumbersList?.map((serialNumber: string) => (
          <x.li mb="8px" key={serialNumber}>
            {serialNumber}
          </x.li>
        ))}
      </ul>
    </div>
  )
}
